import React from "react";
import ReactECharts from "echarts-for-react";

export default function VerticalBarChart({ data, heading, top = "15%", height = "300px" }) {
  const totalItems = data?.valData?.length;
  const visibleItems = 10;

  const options = {
    title: {
      text: heading,
      left: "left", // ⬅️ consistent with HoriBarChart
      textStyle: {
        fontFamily: "Uni Neue",
        fontSize: 18,
        fontWeight: "600",
      },
    },

    grid: {
      left: "5%",
      right: "5%",
      bottom: "10%",
      top: top,
      containLabel: true,
    },

    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: (params) => {
        const item = params[0];
        return `${item.name}<br/><b>${item.value}</b> Chassis`;
      },
    },

    xAxis: {
      type: "category",
      data: data.keyData,
      axisLabel: {
        rotate: 45,
        fontSize: 12,
      },
      axisTick: {
        show: false,
      },
    },

    yAxis: {
      type: "value",
      splitLine: {
        show: false,
      },
      axisLabel: {
        fontSize: 12,
      },
    },

    series: [
      {
        data: data.valData,
        type: "bar",
        barWidth: 20,
        barMinHeight: 10,
        itemStyle: {
          color: "#2A86FF", // Matching your chart theme
          borderRadius: [5, 5, 0, 0],
        },
        label: {
          show: true,
          position: "top",
          formatter: "{c}",
          color: "#000",
          fontSize: 13,
          fontWeight: "500",
        },
      },
    ],

    ...(totalItems > visibleItems && {
      dataZoom: [
        {
          type: "slider",
          xAxisIndex: 0,
          start: 0,
          end: (visibleItems / totalItems) * 100,
          height: 8,
          showDetail: false,
          handleSize: 10,
          handleColor: "#2A5775",
          fillerColor: "#2A5775",
          backgroundColor: "#ccc",
          zoomLock: true,
          bottom: 0,
        },
      ],
    }),
  };

  return (
    <ReactECharts
      option={options}
      style={{ height: height, width: "100%" }}
    />
  );
}